"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapInCustHookChangeError = exports.InjectHook = exports.CreateHookInjection = void 0;
const react_1 = __importStar(require("react"));
const errors_1 = require("../utils/errors");
exports.CreateHookInjection = (hook, ...Wrappers) => {
    return (Component) => {
        function HookWrapper(props, ref) {
            const extraProps = hook(props);
            const AllProps = Object.assign(Object.assign(Object.assign({}, props), extraProps), { ref });
            let rendered = react_1.default.createElement(Component, Object.assign({}, AllProps));
            for (let i = Wrappers.length - 1; i >= 0; --i) {
                const Wrapper = Wrappers[i];
                rendered = react_1.default.createElement(Wrapper, Object.assign({}, AllProps, { children: rendered }));
            }
            return rendered;
        }
        const useConnectedComponent = react_1.default.forwardRef(HookWrapper);
        return useConnectedComponent;
    };
};
exports.InjectHook = (Component, hook, ...Wrappers) => {
    return exports.CreateHookInjection(hook, ...Wrappers)(Component);
};
exports.WrapInCustHookChangeError = (Component) => {
    class HookChangeBoundary extends react_1.default.Component {
        constructor() {
            super(...arguments);
            this.state = { key: 0 };
            this.componentDidCatch = (error, info) => {
                if (!(error instanceof errors_1.HookChangeError)) {
                    throw error;
                }
                error.hasBeenCaught = true;
                this.setState(({ key }) => ({
                    key: key + 1,
                }));
            };
        }
        render() {
            const _a = this.props, { __$__ref } = _a, restProps = __rest(_a, ["__$__ref"]);
            return (react_1.default.createElement(Component, Object.assign({}, this.props, { key: this.state.key, ref: __$__ref })));
        }
    }
    return react_1.forwardRef((props, ref) => (react_1.default.createElement(HookChangeBoundary, Object.assign({}, props, { "__$__ref": ref }))));
};
